import _objectSpread from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
export var defaultColors = {
  black: '#000',
  capeCodeLighter: '#5A6662',
  capeCodeLight: '#39403E',
  capeCode: '#2E3331',
  capeCodDarker: '#222625',
  concreteLighter: '#FAFAFA',
  concreteLight: '#F7F7F7',
  concrete: '#F2F2F2',
  concreteDark: '#EDEDED',
  cyprus: '#003A3B',
  cyprusLight: '#005354',
  disabled: '#D5E0DD',
  disabledText: '#BCC7C4',
  doveGrayLight: '#807D7D',
  doveGrayLightDisabled: '#807D7D80',
  doveGrayOpaque2: '#6765654D',
  doveGrayOpaque: '#67656526',
  doveGray: '#676565',
  doveGrayDark: '#4D4D4D',
  errorOpaque2: '#DD58534D',
  errorOpaque: '#DD58531A',
  error: '#BE123C',
  errorDark: '#DB555C',
  inactive: '#A8A8A8',
  info: '#0284C7',
  mineShaftLight: '#4D4D4D',
  opaqueWhite: 'rgba(255, 255, 255, 0.5)',
  porcelainLight: '#F0F7F5',
  porcelainDark: '#E6EDEB',
  porcelainDarker: '#DAE0DE',
  primaryLight: '#37DBA4',
  primaryOpaque: '#00C38233',
  primary: '#00C381',
  primaryDarker: '#11A876',
  success: '#16A34A',
  warn: '#F97316',
  white: '#FFF'
};
export var defaultTypography = {
  color: defaultColors.capeCode,
  mutedText: defaultColors.doveGray,
  mutedTextHighlight: defaultColors.doveGrayLight,
  fontWeight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  },
  headings: {
    fontFamily: 'Montserrat',
    color: defaultColors.capeCode,
    h1: {
      font: 'Bold 24px/23px Montserrat',
      fontSize: '24px'
    },
    h2: {
      font: 'Bold 20px/23px Montserrat',
      fontSize: '20px'
    },
    h3: {
      font: 'Bold 16px/23px Montserrat',
      fontSize: '16px'
    }
  },
  body: {
    fontFamily: 'Source Sans Pro',
    color: defaultColors.capeCode,
    small: {
      fontSize: '13px',
      lineHeight: '15px'
    },
    regular: {
      fontSize: '14px',
      lineHeight: '15px'
    },
    large: {
      fontSize: '16px',
      lineHeight: '21px'
    }
  }
};
export var themeGenerator = function themeGenerator() {
  var colors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultColors;
  var typographyConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTypography;
  var extraColors = {
    orange: '#CE7B33'
  };
  var spaces = {
    lowFrequencyGammaRay: '1px',
    gammaRay: '2px',
    highFrequencyGammaRay: '4px',
    extremehighFrequencyGammaRay: '5px',
    lowFrequencyXRay: '8px',
    xRay: '12px',
    highFrequencyXRay: '16px',
    lowFrequencyUltraviolet: '20px',
    ultraviolet: '24px',
    highFrequencyUltraviolet: '28px',
    lowFrequencyVisible: '32px',
    visible: '36px',
    highFrequencyVisible: '40px',
    lowFrequencyInfrared: '44px',
    infrared: '48px',
    highFrequencyInfrared: '52px',
    lowFrequencyMicrowave: '56px',
    microwave: '60px',
    highFrequencyMicrowave: '64px',
    lowFrequencyRadio: '68px',
    radio: '72px',
    highFrequencyRadio: '76px'
  };
  var fontSizes = {
    xRay: '12px',
    ultraviolet: '14px',
    visible: '16px',
    infrared: '18px',
    microwave: '20px',
    radio: '22px',
    lowFrequencyAboveRadio: '24px',
    highFrequencyAboveRadio: '28px'
  };
  var lineHeights = {
    lowFrequencyXRay: '18px',
    xRay: '20px',
    ultraviolet: '24px',
    visible: '27px',
    infrared: '30px'
  };
  var fontWeights = {
    xRay: '300',
    // light
    ultraviolet: '400',
    // regular
    visible: '500',
    // medium
    infrared: '600',
    // semiBold
    microwave: '700',
    // bold
    light: '300',
    regular: '400',
    medium: '500',
    semiBold: '600',
    bold: '700'
  };
  var transitions = {
    gammaRay: 'all 100ms ease-in-out',
    visible: 'all 300ms ease-in-out',
    radio: 'all 600ms ease-in-out',
    highFrequencyRadio: 'all 1000ms ease-in-out'
  };
  var opacities = {
    gammaRay: 0.2,
    visible: 0.6,
    radio: 0.8
  };
  var zIndexes = {
    xRay: 1,
    ultraviolet: 10,
    visible: 100,
    infrared: 1000,
    microwave: 1000,
    radio: 10000
  };
  var colorAliases = {
    success: colors.success,
    error: colors.error,
    warn: colors.warn,
    info: colors.info,
    color: colors.white,
    background: colors.concreteLighter,
    body: colors.capeCode,
    headings: colors.capeCode,
    loading: colors.primary
  };
  var gridTheme = {
    row: {
      padding: 15
    },
    col: {
      padding: 15
    },
    container: {
      padding: 15
    }
  };
  var shadow = {
    lowFrequencyVisible: '1px 1px 3px #00000029',
    visible: '0px 1px 2px #CFDDE2',
    highFrequencyVisible: '0px 2px 4px #6BABC880'
  };
  var Theme = {
    global: {
      colors: colors,
      spaces: spaces,
      fontSizes: fontSizes,
      fontWeights: fontWeights,
      transitions: transitions,
      opacities: opacities,
      zIndexes: zIndexes,
      colorAliases: colorAliases,
      gridTheme: gridTheme,
      shadow: shadow,
      typographyConfig: typographyConfig
    },
    components: {
      button: {
        fontFamily: typographyConfig.body.fontFamily,
        fontSize: fontSizes.ultraviolet,
        fontWeight: fontWeights.semiBold,
        padding: "".concat(spaces.lowFrequencyXRay, " ").concat(spaces.highFrequencyXRay),
        transition: transitions.visible,
        iconFontSize: fontSizes.infrared,
        disabled: colors.porcelainDarker,
        disabledText: colors.capeCodeLighter,
        primary: {
          default: colors.primary,
          hover: colors.primaryDarker,
          focused: colors.primaryLight,
          text: colors.white
        },
        outline: {
          disabledText: colors.doveGrayLight,
          disabledBorder: "1px solid ".concat(colors.doveGrayLight),
          focusedBackground: colors.primaryOpaque,
          focused: colors.primaryDarker,
          hover: colors.primaryOpaque,
          text: colors.capeCode,
          border: "1px solid ".concat(colors.primary)
        },
        secondary: {
          default: colors.doveGray,
          hover: colors.doveGrayDark,
          focused: colors.doveGrayLight,
          text: colors.white
        },
        outlineSecondary: {
          focusedBackground: colors.doveGrayOpaque2,
          hover: colors.doveGrayOpaque,
          text: colors.capeCode,
          border: "1px solid ".concat(colors.doveGray)
        },
        tertiary: {
          border: "1px solid ".concat(colors.porcelainDarker),
          default: colors.concreteLighter,
          disabled: colors.porcelainDarker,
          disabledColor: colors.white,
          hover: colors.concreteDark,
          focused: colors.porcelainDarker,
          focusedColor: colors.doveGrayLight,
          text: colors.doveGray
        },
        danger: {
          default: colors.error,
          disabledOpacity: 0.3,
          disabledColor: colors.concrete,
          opacity: 1,
          hover: 0.8,
          focused: colors.porcelainDarker,
          text: colors.white
        },
        outlineDanger: {
          disabledText: colors.concrete,
          disabledBorder: "1px solid ".concat(colors.errorOpaque2),
          disabledBackground: colors.errorOpaque2,
          focusedBackground: colors.errorOpaque2,
          hover: colors.errorOpaque,
          text: colors.error,
          border: "1px solid ".concat(colors.error)
        }
      },
      select: {
        backgroundColor: colors.white,
        paddingBottom: spaces.lowFrequencyUltraviolet,
        borderRadius: spaces.gammaRay,
        belowSelectIndex: zIndexes.xRay,
        selectIndex: zIndexes.ultraviolet,
        hoverColor: colors.concreteLight
      },
      input: {
        transition: transitions.visible,
        fastTransition: transitions.gammaRay,
        disabled: colors.doveGrayLightDisabled,
        unselected: colors.doveGrayLight,
        text: colors.cyprusLight,
        checkColor: colors.white,
        fontFamily: typographyConfig.body.fontFamily,
        fontSize: fontSizes.ultraviolet,
        lineHeight: lineHeights.ultraviolet,
        fontWeight: fontWeights.visible,
        marginLeft: spaces.lowFrequencyXRay,
        boxShadowcolor: colors.doveGray,
        boxShadowcolorVariant: colors.cyprusLight,
        boxShadowcolorFocus: colors.primary,
        errorColor: colors.error,
        iconRight: spaces.xRay,
        iconTop: spaces.xRay,
        switch: {
          enabled: colors.primaryLight,
          disabled: colors.primaryDarker,
          disabledVariant: colors.primary
        },
        inputText: {
          color: colors.capeCodeLighter,
          fontWeight: fontWeights.ultraviolet,
          padding: "".concat(spaces.xRay, " ").concat(spaces.highFrequencyXRay),
          labelColor: colors.doveGrayDark,
          labelColorFocus: colors.primaryLight,
          labelColorHover: colors.cyprusLight,
          labelTop: spaces.highFrequencyXRay,
          labelPadding: "0 ".concat(spaces.lowFrequencyXRay),
          labelLeft: "calc(".concat(spaces.highFrequencyXRay, " - ").concat(spaces.lowFrequencyXRay, ")"),
          labelBackground: colors.white,
          labelFontSize: fontSizes.xRay,
          labelFontWeight: fontWeights.visible,
          messageMargin: "".concat(spaces.lowFrequencyXRay, " 0")
        },
        inputPassword: {
          paddingRight: spaces.visible
        },
        checkbox: {
          borderChecked: colors.primary
        },
        option: {
          after: colors.primary,
          border: "1px solid ".concat(colors.doveGrayLight),
          borderChecked: colors.doveGrayDark,
          borderFocus: '0 2px',
          borderHover: colors.cyprusLight,
          borderUnchecked: colors.doveGrayLight,
          fontWeight: fontWeights.regular,
          lineHeight: '22px',
          marginLeft: '14px',
          text: colors.doveGrayLight,
          textHover: colors.capeCodeLighter
        },
        highlighted: {
          borderHover: colors.doveGrayLight,
          containerPadding: '18px',
          containerBorder: "1px solid ".concat(colors.porcelainDarker),
          containerBorderRadius: '5px',
          containerBorderColorChecked: colors.primary,
          containerOpacity: 0.8,
          containerBackground: colors.concreteLighter,
          containerBackgroundChecked: 'none',
          containerBorderColor: colors.porcelainDarker
        },
        helper: {
          background: colors.primary,
          iconColor: colors.white,
          iconSize: '10px'
        }
      },
      formGroup: {
        transition: transitions.visible,
        marginTop: spaces.lowFrequencyXRay,
        marginLeft: spaces.highFrequencyXRay,
        padding: spaces.highFrequencyXRay,
        color: colors.white,
        boxShadowcolor: colors.doveGray,
        boxShadowcolorVariant: colors.cyprusLight
      },
      tag: _objectSpread(_objectSpread({}, colorAliases), {}, {
        color: colors.white,
        padding: "".concat(spaces.gammaRay, " ").concat(spaces.lowFrequencyXRay),
        fontSize: fontSizes.xRay,
        lineHeight: lineHeights.xRay,
        fontWeight: fontWeights.visible
      }),
      standardTag: {
        fontFamily: typographyConfig.body.fontFamily,
        fontSize: '13px',
        fontWeight: fontWeights.regular,
        lineHeight: lineHeights.xRay,
        border: "1px solid ".concat(colors.concrete),
        lightColor: colors.doveGrayLight,
        darkColor: colors.white
      },
      typography: {
        config: _objectSpread({}, typographyConfig),
        headingsFontFamily: typographyConfig.headings.fontFamily,
        bodyFontFamily: typographyConfig.body.fontFamily,
        color: colors.capeCode,
        fontH1: typographyConfig.headings.h1.font,
        fontH2: typographyConfig.headings.h2.font,
        fontH3: typographyConfig.headings.h3.font,
        smallFontSize: typographyConfig.body.small.fontSize,
        smallLineHeight: typographyConfig.body.small.lineHeight,
        fontSize: typographyConfig.body.regular.fontSize,
        lineHeight: typographyConfig.body.regular.lineHeight,
        largeFontSize: typographyConfig.body.large.fontSize,
        largeLineHeight: typographyConfig.body.large.lineHeight,
        textMargin: "".concat(spaces.lowFrequencyXRay, " 0"),
        sideBySideMarginLeft: spaces.lowFrequencyXRay
      },
      slider: {
        transition: transitions.visible
      },
      table: {
        transition: transitions.visible,
        borderColor: colors.concreteDark,
        striped: colors.concreteLighter,
        hover: colors.concreteLight,
        fontSize: fontSizes.ultraviolet,
        lineHeight: lineHeights.xRay,
        headLineHeight: lineHeights.lowFrequencyXRay,
        fontWeight: fontWeights.ultraviolet,
        color: colors.capeCodeLighter,
        headColor: colors.capeCodeDark,
        columnPadding: spaces.highFrequencyXRay,
        headFontWeight: fontWeights.visible
      },
      calendar: {
        backgroundColor: colors.white,
        unselected: colors.capeCode,
        holidayColor: colors.doveGrayLight,
        fontSize: fontSizes.ultraviolet,
        lineHeight: lineHeights.ultraviolet,
        fontWeight: fontWeights.ultraviolet,
        dayFontWeight: fontWeights.semiBold,
        padding: spaces.lowFrequencyUltraviolet,
        monthsPaddingLeft: '50px',
        yearsColors: colors.cyprus,
        yearsFontSize: '18px',
        yearsItemFontSize: '16px',
        yearsItemBackground: colors.concreteLight,
        yearsItemsBorder: "1px solid ".concat(colors.porcelainDarker),
        yearsItemsBackground: colors.white,
        daysMargin: spaces.lowFrequencyXRay,
        weekDaysMargin: "".concat(spaces.highFrequencyXRay, " 0"),
        weekDaysColor: colors.doveGray,
        daysTransition: transitions.gammaRay,
        daysSelectedBackground: colors.primaryLight,
        daysSelectedText: colors.white
      },
      dateRange: {
        backgroundColor: colors.white,
        calendarsPaddingTop: '10px',
        calendarsBorderRadius: '8px',
        calendarsBoxShadow: "0 0 8px 0 #00000052",
        fontSize: fontSizes.ultraviolet,
        fontWeight: fontWeights.ultraviolet,
        lineHeight: lineHeights.ultraviolet,
        controllerColor: colors.doveGrayLight,
        daysMargin: spaces.lowFrequencyXRay,
        dayFontWeight: fontWeights.semiBold,
        daysSelectedText: colors.white,
        daysSelectedBackground: colors.primary,
        daysTransition: transitions.gammaRay,
        daysInRangeBackground: '#00E09419',
        weekDaysTextfontWeight: fontWeights.infrared,
        weekDaysTextColor: '#18181b',
        unselected: colors.capeCode
      },
      notification: {
        colors: {
          success: {
            background: colors.success,
            foreground: colors.white
          },
          error: {
            background: colors.error,
            foreground: colors.white
          },
          warn: {
            background: colors.warn,
            foreground: colors.capeCodeLighter
          },
          info: {
            background: colors.info,
            foreground: colors.white
          }
        },
        transition: transitions.radio,
        padding: "".concat(spaces.highFrequencyXRay, " calc(3 * ").concat(spaces.highFrequencyXRay, ")\n                    ").concat(spaces.highFrequencyXRay, " ").concat(spaces.highFrequencyXRay),
        marginLeft: spaces.highFrequencyXRay,
        marginTop: spaces.lowFrequencyXRay,
        fontSize: fontSizes.ultraviolet,
        mobileFontSize: fontSizes.xRay,
        lineHeight: 1,
        fontWeight: fontWeights.visible,
        closeFontSize: fontSizes.infrared,
        closeTop: spaces.highFrequencyXRay,
        closeRight: '32px',
        zIndex: zIndexes.radio
      },
      popover: {
        color: colors.capeCode,
        darkBackground: colors.cyprus,
        darkColor: colors.white,
        transition: transitions.visible,
        iconBackground: colors.porcelainDarker,
        iconColor: colors.doveGrayDark,
        backgroundColor: colors.white,
        zIndex: 950,
        arrowLeft: spaces.highFrequencyXRay,
        arrowMargin: spaces.highFrequencyXRay
      },
      progress: {
        transition: transitions.radio,
        marginLeft: spaces.xRay,
        barColor: colors.concreteLight,
        barHeight: spaces.lowFrequencyXRay,
        colors: {
          green: colors.primary,
          red: colors.error,
          yellow: colors.warn,
          blue: colors.info,
          orange: extraColors.orange
        }
      },
      card: {
        padding: spaces.highFrequencyXRay,
        lightBackground: colors.white,
        lightColor: colors.capeCode,
        titleLightColor: colors.capeCodeLight,
        darkBackground: colors.cyprus,
        darkColor: colors.white,
        cardBodyMargin: "".concat(spaces.lowFrequencyXRay, " 0 0 0"),
        shadow: shadow.lowFrequencyVisible
      },
      newCard: {
        shadow: '0px 3px 15px 0px #0000000F'
      },
      contentDropdown: {
        arrowBorder: "1px solid ".concat(colors.primary),
        arrowBorderDisabled: colors.concreteLight,
        arrowBorderRadius: '2px',
        arrowContainerPadding: '12px',
        arrowFontFamily: typographyConfig.body.fontFamily,
        arrowFontSize: typographyConfig.body.regular.fontSize,
        arrowFontWeight: fontWeights.semiBold,
        transition: transitions.visible,
        padding: spaces.highFrequencyXRay,
        lightBackground: colors.concreteLight,
        transitionDuration: '600ms',
        maxHeight: '786px',
        iconColor: colors.primary,
        lightColor: colors.capeCodeLighter,
        darkBackground: colors.cyprus,
        darkColor: colors.concreteLight,
        collapsablePadding: "0 ".concat(spaces.xRay, " ").concat(spaces.xRay),
        iconSize: '16px'
      },
      highlightedText: _objectSpread(_objectSpread({}, colorAliases), {}, {
        fontWeight: fontWeights.visible,
        paddingLeft: '14px',
        asideTextPadding: '14px',
        largeSubTitleMarginTop: spaces.highFrequencyGammaRay,
        small: {
          margin: '0',
          title: {
            color: colors.doveGray,
            font: {
              weight: 500,
              size: '14px'
            }
          },
          subtitle: {
            color: colors.doveGrayLight,
            font: {
              weight: 400,
              size: '14px'
            }
          }
        },
        regular: {
          margin: '4px',
          title: {
            color: colors.headings,
            font: {
              weight: 500,
              size: '18px'
            }
          },
          subtitle: {
            color: colorAliases.doveGrayLight,
            font: {
              weight: 400,
              size: '14px'
            }
          }
        },
        large: {
          margin: '8px',
          title: {
            color: colors.headings,
            font: {
              weight: 600,
              size: '20px'
            }
          },
          subtitle: {
            color: colorAliases.doveGrayLight,
            font: {
              weight: 400,
              size: '16px'
            }
          }
        }
      }),
      textHeader: _objectSpread(_objectSpread({}, colorAliases), {}, {
        fontWeight: fontWeights.microwave,
        paddingLeft: spaces.lowFrequencyUltraviolet,
        largeSubTitleMarginTop: '5px'
      }),
      modal: _objectSpread(_objectSpread({}, colorAliases), {}, {
        transition: transitions.visible,
        padding: spaces.highFrequencyVisible,
        mobilePadding: "".concat(spaces.highFrequencyInfrared, " ").concat(spaces.xRay, " ").concat(spaces.xRay),
        bodyMarginTop: spaces.highFrequencyVisible,
        footerMarginTop: spaces.highFrequencyVisible,
        zIndex: zIndexes.microwave,
        backgroundColor: colors.white,
        fontSize: fontSizes.ultraviolet,
        fontWeight: fontWeights.ultraviolet,
        lineHeight: fontSizes.ultraviolet,
        color: colors.doveGrayDark,
        iconColor: colors.doveGrayLight
      }),
      inputFileUpload: {
        fontSize: fontSizes.xRay,
        iconFontSize: fontSizes.lowFrequencyAboveRadio,
        iconColor: colors.primary,
        fontWeight: fontWeights.ultraviolet,
        errorColor: colors.error,
        bottomLabelColor: colors.doveGrayDark,
        lineHeight: lineHeights.ultraviolet,
        topLabelColor: colors.doveGrayDark,
        fileNameColor: colors.doveGrayDark,
        fileIconFontSize: fontSizes.visible,
        marginRightFileIcon: spaces.extremehighFrequencyGammaRay,
        dropZoneBorderRadius: spaces.gammaRay,
        dropZoneBorderWidth: spaces.lowFrequencyGammaRay
      },
      sideNav: {
        logo: {
          backgroundColor: colors.capeCodDarker,
          height: spaces.lowFrequencyMicrowave // same height as header

        },
        top: '90px',
        right: '0',
        defaultWidth: '230px',
        collapsedWidth: '60px',
        backgroundColor: colors.capeCode,
        color: colors.doveGrayLight,
        collapseButton: {
          fontSize: '20px',
          zIndex: zIndexes.microwave + 10
        },
        mobileColor: colors.capeCode,
        fontSize: fontSizes.ultraviolet,
        fontWeight: fontWeights.ultraviolet,
        lineHeight: fontSizes.microwave,
        transition: transitions.visible,
        zIndex: 800,
        item: {
          icon: {
            maxWidth: spaces.ultraviolet,
            width: spaces.highFrequencyXRay,
            margin: spaces.lowFrequencyUltraviolet,
            color: colors.mineShaftLight
          },
          active: {
            icon: {
              color: colors.primary
            },
            fontWeight: fontWeights.xRay,
            color: colors.primary,
            backgroundColor: 'transparent'
          },
          marginRight: spaces.lowFrequencyXRay,
          marginTop: spaces.lowFrequencyXRay,
          padding: "".concat(spaces.xRay, " ").concat(spaces.highFrequencyXRay),
          collapsablePadding: "0 ".concat(spaces.xRay, " ").concat(spaces.xRay),
          fontWeight: fontWeights.infrared
        },
        subNavItems: {
          padding: "".concat(spaces.highFrequencyXRay, " ").concat(spaces.highFrequencyXRay, "\n                        ").concat(spaces.highFrequencyXRay, " ").concat(spaces.highFrequencyXRay),
          color: colors.doveGrayLight,
          closeIcon: {
            top: spaces.highFrequencyXRay,
            right: spaces.highFrequencyXRay
          }
        },
        section: {
          background: colors.capeCodDarker,
          color: colors.white,
          margin: '15px 0 10px 0',
          padding: '8px 16px'
        }
      },
      link: {
        transition: transitions.visible,
        color: colors.primaryDarker,
        unselectedColor: colors.primary
      },
      tabs: {
        transition: transitions.visible,
        title: {
          padding: "".concat(spaces.highFrequencyXRay, " ").concat(spaces.highFrequencyGammaRay),
          marginLeft: spaces.visible,
          color: colors.capeCode,
          bar: colors.primary,
          unselectedColor: colors.doveGrayLightDisabled
        }
      },
      header: {
        colors: {
          mobile: {
            background: colors.capeCode,
            foreground: colors.white
          },
          desktop: {
            background: colors.white,
            foreground: colors.capeCode
          }
        },
        height: spaces.lowFrequencyMicrowave,
        // same height as sidebar logo
        transition: transitions.visible,
        padding: spaces.highFrequencyGammaRay,
        zIndex: 900,
        backgroundColor: colors.white,
        borderBottom: "1px solid ".concat(colors.doveGrayLightDisabled),
        group: {
          margin: spaces.lowFrequencyXRay
        },
        item: {
          padding: spaces.highFrequencyXRay,
          popover: {
            borderLeft: "".concat(spaces.lowFrequencyXRay, " solid #f0f0f0"),
            borderRight: "".concat(spaces.lowFrequencyXRay, " solid #f0f0f0"),
            borderBottom: "".concat(spaces.highFrequencyXRay, " solid ").concat(colors.white),
            right: "".concat(spaces.lowFrequencyXRay),
            top: "-".concat(spaces.highFrequencyXRay)
          },
          text: {
            color: colors.cyprusLight,
            fontSize: fontSizes.xRay,
            fontWeight: fontWeights.infrared,
            letterSpacing: '0.66px'
          }
        }
      },
      skeleton: {
        background: '#dfdfdf',
        shineBackground: '#f6f6f6'
      },
      loading: {
        zIndex: 780,
        color: colorAliases.loading
      },
      stepper: {
        actualFontSize: '16px',
        actualColor: colors.primary,
        progressBorderColor: colors.porcelainDarker,
        circleColor: colors.primary,
        circleFontSize: '14px',
        circleFontWeight: fontWeights.semiBold,
        circleStroke: colors.primary,
        circleTextLineHeight: '24px',
        circleTransition: '350ms',
        fontFamily: typographyConfig.body.fontFamily,
        lineHeight: '20px',
        nextFontSize: '12px',
        nextColor: colors.doveGrayLight
      },
      displayInput: {
        padding: '0 0 10px 0',
        width: '320px'
      }
    }
  };
  return Theme;
};
export default themeGenerator;